import api from './axios';

export const searchPlaces = (q) =>
  api.get('/discover/geocode/search', { params: { q } }).then((r) => r.data);
